// Shared login module — imported by webpack at build time via @xolo/shared/login.
//
// Provides: login tab switching, SmartID polling, CSRF token refresh on submit.
//
// Usage (in each project's webpack entry point):
//   import { createLogin } from '@xolo/shared/login';
//
//   const Login = createLogin({
//       csrfUrl: '/hub/csrf',
//       onTabClick: (targetId) => showImage(targetId),
//       onInit: () => { initPlanSelect(); initLanguageSelect(); }
//   });

export function createLogin({ csrfUrl, onTabClick, onInit }) {

    let Login = {
        init: () => {
            Login.loginTabs = $('[data-bind="loginTab"]');
            Login.loginTabContainers = $('[data-bind="loginTabContainer"]');

            initLogin();
            updateCsrfOnSubmit();
            if (typeof onInit === 'function') onInit();
        },

        pollSmartId: (pollUrl, successUrl, failureUrl, intervalMillis, fromFail) => {
            window.setTimeout(() => {
                $.ajax({method: "GET", url: pollUrl, dataType: "text", cache: false, headers: {"cache-control": "no-cache"}})
                    .done((data) => {
                        if (data === 'RUNNING') {
                            Login.pollSmartId(pollUrl, successUrl, failureUrl, intervalMillis + 500, false);
                        } else if (data === 'SUCCESS') {
                            window.location.href = successUrl;
                        } else {
                            window.location.href = failureUrl;
                        }
                    })
                    .fail((jqXHR, textStatus, errorThrown) => {
                        fromFail ? window.location.href = failureUrl : Login.pollSmartId(pollUrl, successUrl, failureUrl, 1000, true);
                    });
            }, intervalMillis);
        }
    };

    function initLogin() {
        if (Login.loginTabs.length) {
            Login.loginTabs.on('click', (e) => {
                let targetId = $(e.currentTarget).attr('href');

                showTab(targetId);
                if (typeof onTabClick === 'function') onTabClick(targetId);
                return false;
            });
        }
    }

    function showTab(tabContainerSelector) {
        Login.loginTabs.removeClass('active');
        Login.loginTabs.filter('[href="' + tabContainerSelector + '"]').addClass('active');

        Login.loginTabContainers.removeClass('active');
        Login.loginTabContainers.filter(tabContainerSelector).addClass('active').find('INPUT[type="email"]').focus();
    }

    function updateCsrfOnSubmit() {
        let forms = document.querySelectorAll('[data-bind="csrfReload"]');

        if (!forms.length) return;

        forms.forEach(form => {
            form.addEventListener('submit', (e) => {
                e.preventDefault();

                fetch(csrfUrl)
                    .then(res => res.ok ? res.json() : console.error('Fetching CSRF failed!'))
                    .then(data => {
                        form.querySelector(`input[name='${data.parameterName}']`).value = data.token
                        form.submit();
                    });
            });
        })
    }

    return Login;
}
